import React from 'react';
import { Image, StyleSheet, View, TouchableOpacity, Text, ScrollView } from 'react-native';

import { FileSystem, FaceDetector } from 'expo';

const pictureSize = 150;

export default class GalleryScreen extends React.Component {
	state = {
		faces: {},
		images: {},
		photos: []
	};
	_mounted = false;

	componentDidMount() {
		this._mounted = true;
		this._getPhotosAsync().catch(error => {
			console.error(error);
		});
	}

	async _getPhotosAsync() {
		//let photos = await CameraRoll.getPhotos({ first: 4 });
		//this.setState({ photos });
	}

	componentWillUnmount() {
		this._mounted = false;
	}

	getImageDimensions = ({ width, height }) => {
		if (width > height) {
			const scaledHeight = (pictureSize * height) / width;
			return {
				width: pictureSize,
				height: scaledHeight,

				scaleX: pictureSize / width,
				scaleY: scaledHeight / height,

				offsetX: 0,
				offsetY: (pictureSize - scaledHeight) / 2
			};
		} else {
			const scaledWidth = (pictureSize * width) / height;
			return {
				width: scaledWidth,
				height: pictureSize,

				scaleX: scaledWidth / width,
				scaleY: pictureSize / height,

				offsetX: (pictureSize - scaledWidth) / 2,
				offsetY: 0
			};
		}
	};

	_renderPhotos(photos) {
		let images = [];
		for (let { node: photo } of photos.edges) {
			images.push(<Image source={photo.image} resizeMode="contain" style={{ height: 100, width: 100, resizeMode: 'contain' }} />);
		}
		return images;
	}

	render() {
		let { photos } = this.state;
		return (
			<View style={styles.container}>
				<TouchableOpacity style={styles.backButton} onPress={this.props.onPress}>
					<Text>Back</Text>
				</TouchableOpacity>
				<ScrollView contentComponentStyle={{ flex: 1 }}>
					<View style={styles.pictures}>{photos ? this._renderPhotos(photos) : <Text style={styles.paragraph}>Fetching photos...</Text>}</View>
				</ScrollView>
			</View>
		);
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		paddingTop: 20
	},
	pictures: {
		flex: 1,
		flexWrap: 'wrap',
		flexDirection: 'row'
	},
	picture: {
		position: 'absolute',
		bottom: 0,
		right: 0,
		left: 0,
		top: 0,
		resizeMode: 'contain'
	},
	pictureWrapper: {
		width: pictureSize,
		height: pictureSize,
		margin: 5
	},
	facesContainer: {
		position: 'absolute',
		bottom: 0,
		right: 0,
		left: 0,
		top: 0
	},
	face: {
		borderWidth: 2,
		borderRadius: 2,
		position: 'absolute',
		borderColor: '#FFD700',
		justifyContent: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.5)'
	},
	faceText: {
		color: '#FFD700',
		fontWeight: 'bold',
		textAlign: 'center',
		margin: 2,
		fontSize: 10,
		backgroundColor: 'transparent'
	},
	backButton: {
		padding: 20,
		marginBottom: 4,
		backgroundColor: 'indianred'
	},
	paragraph: {
		margin: 24,
		fontSize: 18,
		fontWeight: 'bold',
		textAlign: 'center',
		color: '#34495e'
	}
});
